module.exports = __webpack_public_path__ + "static/media/daily-coin.ab138a55.svg";